/**
 * Checks if a string contains Hebrew characters
 */
export const containsHebrew = (text: string | undefined): boolean => {
  if (!text) return false;
  // Hebrew Unicode range
  const hebrewRegex = /[\u0590-\u05FF\uFB1D-\uFB4F]/;
  return hebrewRegex.test(text);
};

/**
 * Determines the appropriate text direction based on content
 */
export const getTextDirection = (text: string | undefined): "rtl" | "ltr" => {
  if (!text) return "ltr";
  return containsHebrew(text) ? "rtl" : "ltr";
}; 